import {
  Box,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ServiceTicket from "./panles/ServiceTicket";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentCard from "./panles/PaymentCard";
import WDBox from "../../../MaterialComponents/WDBox";
import AppService from "../../../Configurations/Appservice";
import { useDispatch } from "react-redux";
import { updateScreenTitle } from "../../../LayoutContainers/AppLayout/redux/AppSlice";
import { APP_CONSTANTS } from "../../../Configurations/AppConstants";

const PartnerOrgDashboard = () => {
  const [pendingTickets, setPendingTickets] = useState([]);
  const [organisation, setOrganisation] = useState();
  const [pendingPaymentItem, setPendingPaymentItem] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Dashboard"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    const params = { orgId: organisation };
    AppService.get("v1/dashboard/partnerDash", { params })
      .then((response) => {
        console.log(response);
        setPendingTickets(response.customerTickets || []);
        setPendingPaymentItem(response.pendingPaymentItem || {});
      })
      .catch((error) => {
        alert("error");
      })
      .finally(() => {});
  }, [organisation]);

  const _navigateToPendingTickets = (ticket) => {
    navigate("/ADM-Ticket/pending-tickets", {
      state: {
        status: ticket.serviceName,
        screenType: APP_CONSTANTS.PARTNER_DASH,
      },
    });
  };

  const _renderPendingTickets = (ticket) => {
    return (
      <Grid item xs={12} md={4}>
        <ServiceTicket ticket={ticket} onClick={() => _navigateToPendingTickets(ticket)} />
      </Grid>
    );
  };

  const EmptyTicketInfo = () => {
    return (
      <Box m={2}>
        <Card sx={{ p: 2 }}>
          <Typography>No Tickets Pending</Typography>
        </Card>
      </Box>
    );
  };

  return (
    <WDBox>
      <Grid container spacing={1.5}>
        {pendingTickets && pendingTickets.map(_renderPendingTickets)}
        {!pendingTickets.length && <EmptyTicketInfo />}
      </Grid>
    </WDBox>
  );
};

export default PartnerOrgDashboard;
